<template>
  <div>
    <v-container>
      <v-row v-if="user">
        <v-col cols="12" style="margin-top: 60px;" />
        <v-col cols="12">
          <v-row align="center">
            <v-img
              class="avatar"
              :src="user.user.avatarUrl || ''"
              width="190"
              :aspect-ratio="1"
            />
            <v-col class="pa-8 handleText"> @{{ user.user.handle }} </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" style="margin-top: 60px;" />
        <v-row>
          <template v-for="token in displayTokens">
            <v-col :key="token._id" cols="3">
              <TokenView
                :collectible="token.collectible"
                :moment="token.moment"
                :token="token"
                :showClaim="true"
                :showListing="true"
                :tokenCount="tokenCount(token)"
                @claimToken="claimToken"
              />
            </v-col>
          </template>
        </v-row>
        <v-col cols="12" style="margin-top: 90px;" />
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    components: {
      TokenView: () => import('../components/TokenView.vue'),
    },
    props: ['user', 'displayTokens', 'momentCount', 'tokenCount'],
    methods: {
      claimToken: function(token) {
        this.$emit('claimToken', token);
      },
    },
  };
</script>

<style scoped>
  .avatar {
    box-sizing: border-box;

    max-width: 190px;
    height: 190px;

    /* Colour System 2/Shade/shade-50 */

    background: #ebebeb;
    mix-blend-mode: normal;
    /* Colour System 2/Shade/shade-100 */

    border: 3px solid #c0c0c0;
    border-radius: 95px;
  }

  .handleText {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 32px !important;
    line-height: 40px !important;

    color: #151515;
  }

  .nameText {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 24px !important;
    text-align: center;
    color: #151515;
  }
  .rarityText {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 12px !important;
    text-align: center;
    color: #151515;
    text-transform: capitalize;
  }
</style>
